import { FunctionComponent } from "react";
import {
  getStatusTone,
  STATUS_TONE_CLASSES,
  StatusKind,
  StatusTone,
} from "./status_colors";

export interface StatusBadgeProps {
  status?: string;
  kind?: StatusKind;
  fallback?: string;
  tone?: StatusTone;
}

const StatusBadge: FunctionComponent<StatusBadgeProps> = ({
  status,
  kind = "order",
  fallback = "-",
  tone,
}) => {
  const label = status && status.trim() ? status : fallback;
  const resolvedTone = tone ?? getStatusTone(status, kind);
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-0.5 text-xs rounded-full font-medium border whitespace-nowrap ${STATUS_TONE_CLASSES[resolvedTone]}`}
    >
      {label}
    </span>
  );
};

export default StatusBadge;
